import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import apiService from '../../../utils/api/service'
import jwtDecode from 'jwt-decode'
import { statusType } from '../../../utils/statusTypes'

const initialState = {
  userCode: null,
  isLoggedIn: false,
  token: null,
  refreshToken: null,
  errorMessage: null,
  status: statusType.idle,
}

export const login = createAsyncThunk('user/login', async ({ userCode, password }, thunkAPI) => {
  try {
    const { fetchPromise } = apiService.authenticate(userCode, password)
    const decodedJson = await fetchPromise

    return thunkAPI.fulfillWithValue({
      userCode: jwtDecode(decodedJson.token).sub,
      token: decodedJson.token,
      refreshToken: decodedJson.refreshToken
    })
  } catch (e) {
    console.log('Error', e.message)
    return thunkAPI.rejectWithValue({ message: e.message })
  }
})

export const fetchNewToken = createAsyncThunk('user/requestTokenRefresh', async ({ refreshToken }, thunkAPI) => {
  try {
    const { fetchPromise } = apiService.authenticateRefresh(refreshToken)
    const decodedJson = await fetchPromise
    return thunkAPI.fulfillWithValue({
      token: decodedJson.token,
      refreshToken: decodedJson.refreshToken
    })
  } catch (e) {
    console.log('Error', e.message)
    return thunkAPI.rejectWithValue({ message: e.message })
  }
})

// Export slice
const userSlice = createSlice({
  name: 'user',
  initialState,
  // Redux Toolkit allows us to write "mutating" logic in reducers. It
  // doesn't actually mutate the state because it uses the immer library,
  // which detects changes to a "draft state" and produces a brand new
  // immutable state based off those changes
  reducers: {
    logout: () => initialState,
  },
  // Thunk functions
  extraReducers: {
    [login.pending]: (draftState) => {
      draftState.status = statusType.loading
      draftState.errorMessage = initialState.errorMessage
    },
    [login.fulfilled]: (draftState, { payload }) => {
      draftState.status = statusType.idle
      draftState.isLoggedIn = true
      draftState.userCode = payload.userCode
      draftState.token = payload.token
      draftState.refreshToken = payload.refreshToken
    },
    [login.rejected]: (draftState, { payload }) => {
      draftState.status = statusType.error
      draftState.errorMessage = payload.message
    },
    [fetchNewToken.fulfilled]: (draftState, { payload }) => {
      draftState.token = payload.token
      draftState.refreshToken = payload.refreshToken
    },
  },
})

// Export selector
export const userSelector = (state) => state.user

export const { logout } = userSlice.actions

// Export reducer
export default userSlice.reducer
